import { render, staticRenderFns } from "./PageAdmin.vue?vue&type=template&id=5ae780b7"
import script from "./PageAdmin.vue?vue&type=script&lang=js"
export * from "./PageAdmin.vue?vue&type=script&lang=js"
import style0 from "./PageAdmin.vue?vue&type=style&index=0&id=5ae780b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports